import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appActions from './actions/app-actions';
import AlbumArt from './AlbumArt';

class Track extends Component {

  render(){
    return (
      <div className={ "Track " + this.props.oddEven }>
        <AlbumArt album={ this.props.album } albumArtUrl={ this.props.album_art.small } />
        <h1 className="Artist">{ this.props.artist }</h1>
        <h1 className="Title">{ this.props.title }</h1>
        <div className="clearfix"></div>
      </div>
    );
  }
}

function mapStateToProps(state, props){
  return {
    app: state.app
  }
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Track);



// WEBPACK FOOTER //
// ./src/Track.js